import axios from 'axios'

const isDeveloppement = false
const baseURL = isDeveloppement ? 'http://localhost:8080/api/v1' : 'https://www.sirycar.com/api/api/v1';
const baseUrlNet = isDeveloppement ? 'http://localhost:8080/carImagesDir/' : 'https://www.sirycar.com/carImagesDir/';

//this is just for test

export { baseURL, baseUrlNet}